import React from 'react';

/*
 *  @Description:   Stateless component that renders a Playlist icon.
 */

const Playlist = ( props ) => {

    return (<g id="path">
            <polygon
                points="10 8 16 12 10 16 10 8"/>
            <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="2"
                ry="2"/>
        </g>
    )

};

export default Playlist;

